import { leaguesV2Api } from "../leaguesV2Api";
import type { Clubhouse_LeagueV2HandicapHistoryDto } from "../../types/handicap";

type GetHandicapHistoryArgs = {
  facilityId: string;
  leagueId: string;
  memberId: string;
  /** `older` and `excluded`, comma-separated. Omit for the current window. */
  include?: string;
  page?: number;
  pageSize?: number;
};

const handicapEndpoints = leaguesV2Api.injectEndpoints({
  endpoints: (build) => ({
    getHandicapHistory: build.query<
      Clubhouse_LeagueV2HandicapHistoryDto,
      GetHandicapHistoryArgs
    >({
      // NOTE: `leagues` segment (not `league-v2`) — matches roster/rounds routes.
      query: ({ facilityId, leagueId, memberId, include, page, pageSize }) => {
        const params = new URLSearchParams();
        if (include) params.set("include", include);
        if (page != null) params.set("page", String(page));
        if (pageSize != null) params.set("pageSize", String(pageSize));
        const query = params.toString();
        return `/api/facility/${facilityId}/leagues/${leagueId}/roster/${memberId}/handicap-history${query ? `?${query}` : ""}`;
      },
      // Composite id: memberId is a per-league roster id, not globally unique,
      // so scope the tag by facility + league + member to avoid a future
      // invalidation bleeding across leagues/facilities.
      providesTags: (_, __, { facilityId, leagueId, memberId }) => [
        {
          type: "HandicapHistory",
          id: `${facilityId}:${leagueId}:${memberId}`,
        },
      ],
    }),
  }),
});

export const { useGetHandicapHistoryQuery } = handicapEndpoints;
